import interestsService from '../../services/api/interests'
import { useQuery } from 'react-query'
import STALE_TIMES from '../common/stale-times'

const useInterests = () => {
    const { data, isLoading } = useQuery('interests', interestsService.fetch, { staleTime: STALE_TIMES.DAY })
    return {
        isBusy: isLoading,
        interests: data || [],
    }
}

export default useInterests